<template>
  <div class="TmTextEdit">
    <el-tabs :stretch="true" value="style">
      <el-tab-pane
        :label="$t('lcd.Editor.Style')"
        name="style"
        class="style-pane"
      >
        <attr-row
          :label="$t('lcd.Editor.Layer Name') + ' : ' + conf.name"
        ></attr-row>
        <attr-row :label="$t('lcd.Editor.Text Content')">
          <el-tooltip placement="top" slot="hint">
            <div slot="content">
              {{ $t("lcd.Editor.Line Break marks") }} <br />
              {{ $t("lcd.Editor.Single quotation marks") }} <br />
              {{ $t("lcd.Editor.Double quotation marks") }} <br />
              <b style="color: red">{{ $t("lcd.Editor.No replace") }}</b
              ><br />
              <b style="color: red">{{
                $t("lcd.Editor.Replace in English")
              }}</b>
            </div>
            <i class="el-icon-question"></i>
          </el-tooltip>
          <div style="display: flex; justify-content: space-between">
            <el-input size="mini" v-model="conf.text" style="width: 49%" />
            <el-select
              v-model="conf.datasetField"
              size="mini"
              clearable
              filterable
              :placeholder="$t('lcd.Editor.Please Select Data Feild')"
              style="width: 49%"
              @change="datasetFieldChange"
            >
              <el-option
                v-for="field in goodsFields"
                :key="field.value"
                :label="field.label"
                :value="field.value"
              />
            </el-select>
          </div>
          <div style="height: 8px"></div>
          <div style="display: flex; justify-content: space-between">
            <el-input
              v-model="conf.preText"
              :placeholder="$t('lcd.Editor.preText')"
              size="mini"
              style="width: 49%"
            />
            <el-input
              v-model="conf.sufText"
              :placeholder="$t('lcd.Editor.sufText')"
              size="mini"
              style="width: 49%"
            />
          </div>
        </attr-row>
        <attr-row
          class="custom-smaller-btn"
          :label="$t('lcd.Editor.Position and Size')"
        >
          <div style="display: flex; justify-content: space-between">
            <el-input
              v-model="conf.left"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="changeRangeX"
            >
              <template slot="prepend">
                <div style="width: 12px; text-align: center">X</div>
              </template>
            </el-input>
            <el-input
              v-model="conf.top"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="changeRangeY"
            >
              <template slot="prepend">
                <div style="width: 12px; text-align: center">Y</div>
              </template>
            </el-input>
          </div>
          <div style="height: 5px"></div>
          <div style="display: flex; justify-content: space-between">
            <el-input
              v-model="conf.width"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="changeRangeW"
            >
              <template slot="prepend">
                <div style="width: 12px; text-align: center">W</div>
              </template>
            </el-input>
            <el-input
              v-model="conf.height"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="changeRangeH"
            >
              <template slot="prepend"
                ><div style="width: 12px; text-align: center">H</div></template
              >
            </el-input>
          </div>
          <div style="height: 5px"></div>
          <div style="display: flex; justify-content: space-between">
            <el-input
              v-model="conf.lineHeight"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
            >
              <template slot="prepend">
                <div style="width: 24px; text-align: center">LH</div>
              </template>
            </el-input>
            <el-input
              v-model="conf.borderWidth"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="borderWidthChange"
            >
              <template slot="prepend"
                ><div style="width: 24px; text-align: center">BW</div></template
              >
            </el-input>
          </div>
          <div style="height: 5px"></div>
          <div v-if="!pageColor" style="display: flex; align-items: center">
            <i
              class="icon iconfont icon-zitiyanse"
              style="font-size: 12px; margin-right: 6px; color: #000"
            ></i>
            <el-color-picker
              v-model="conf.fontColor"
              show-alpha
              :predefine="predefineColors"
              size="mini"
            />
            <i
              class="icon iconfont icon-beijingse"
              style="font-size: 12px; margin: 0 6px 0 18px; color: #000"
            ></i>
            <el-color-picker
              v-model="conf.bgColor"
              show-alpha
              :predefine="predefineColors"
              size="mini"
            />
            <!-- 边框颜色 -->
            <i
              class="icon iconfont icon-biankuangse1"
              style="font-size: 12px; margin: 0 6px 0 18px; color: #000"
            ></i>
            <el-color-picker
              v-model="conf.borderColor"
              show-alpha
              :predefine="predefineColors"
              size="mini"
            />
          </div>
          <div v-else>
            <!-- 价签字体颜色 -->
            <div
              class="EditorEslColorList"
              v-if="pageColor"
              style="display: flex; align-items: center"
            >
              <i
                class="icon iconfont icon-zitiyanse"
                style="font-size: 12px; margin-right: 6px; color: #000"
              ></i>
              <i v-for="(c, index) in colorList" :key="c.id">
                <span
                  v-if="c.flag.includes(pageColor)"
                  @click="changeFontColor(index)"
                  class="colorLi"
                  :style="{ background: c.color }"
                ></span>
              </i>
            </div>
            <!-- 价签填充色 -->
            <div
              class="EditorEslColorList"
              v-if="pageColor"
              style="display: flex; align-items: center"
            >
              <i
                class="icon iconfont icon-beijingse"
                style="font-size: 12px; margin-right: 6px; color: #000"
              ></i>
              <i v-for="(c, index) in colorList" :key="c.id">
                <span
                  v-if="c.flag.includes(pageColor)"
                  @click="changeBgColor(index)"
                  class="colorLi"
                  :style="{ background: c.color }"
                ></span>
              </i>
              <img
                @click="conf.bgColor = 'rgba(0,0,0,0)'"
                :src="transparentBg"
                style="width: 18px; height: 18px"
              />
            </div>
            <!-- 价签边框颜色 -->
            <div
              class="EditorEslColorList"
              v-if="pageColor"
              style="display: flex; align-items: center"
            >
              <i
                class="icon iconfont icon-biankuangse1"
                style="font-size: 12px; margin-right: 6px; color: #000"
              ></i>
              <i v-for="(c, index) in colorList" :key="c.id">
                <span
                  v-if="c.flag.includes(pageColor)"
                  @click="changeBorderColor(index)"
                  class="colorLi"
                  :style="{ background: c.color }"
                ></span>
              </i>
            </div>
          </div>
          <div style="height: 5px"></div>
          <el-button-group>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Font Bold')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.isBold ? 'primary' : ''"
                @click="handleClickBold"
              >
                <i
                  class="icon iconfont icon-zitijiacu"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Font Italic')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.isItaly ? 'primary' : ''"
                @click="handleClickItaly"
              >
                <i
                  class="icon iconfont icon-zitixieti"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Underline')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.isUnderline === 'underline' ? 'primary' : ''"
                @click="handleClickUnderline"
              >
                <i
                  class="icon iconfont icon-zitixiahuaxian"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Deleteline')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.isUnderline === 'line-through' ? 'primary' : ''"
                @click="handleClickDeleteline"
              >
                <i
                  class="icon iconfont icon-zitishanchuxian"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Auto Wrap')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.autoTurn ? 'primary' : ''"
                @click="handleClickTurn"
              >
                <i
                  class="icon iconfont icon-multilinetext"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Horizontal vertical Switching')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.editDirection ? 'primary' : ''"
                @click="handleClickDirection"
              >
                <i
                  class="icon iconfont icon-hengshuqiehuan"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
          </el-button-group>
          <div style="height: 5px"></div>
          <el-button-group>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Align Left')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.textAlign === 'flex-start' ? 'primary' : ''"
                @click="changeTA('flex-start')"
              >
                <i
                  class="icon iconfont icon-zuoduiqi"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Align Center in Horizontal')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.textAlign === 'center' ? 'primary' : ''"
                @click="changeTA('center')"
              >
                <i
                  class="icon iconfont icon-chuizhijuzhong"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Align Right')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.textAlign === 'flex-end' ? 'primary' : ''"
                @click="changeTA('flex-end')"
              >
                <i
                  class="icon iconfont icon-youduiqi"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Align to Top')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.verticalAlign === 'flex-start' ? 'primary' : ''"
                @click="changeVA('flex-start')"
              >
                <i
                  class="icon iconfont icon-shangduiqi"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Align Center in Vertical')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.verticalAlign === 'center' ? 'primary' : ''"
                @click="changeVA('center')"
              >
                <i
                  class="icon iconfont icon-shuipingjuzhong"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Align to Bottom')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.verticalAlign === 'flex-end' ? 'primary' : ''"
                @click="changeVA('flex-end')"
              >
                <i
                  class="icon iconfont icon-xiaduiqi"
                  style="font-size: 12px"
                ></i>
              </el-button>
            </el-tooltip>
          </el-button-group>
          <div style="height: 5px"></div>
          <div style="display: flex; justify-content: space-between">
            <el-select v-model="conf.font" size="mini" style="width: 49%">
              <el-option
                v-for="item in allFontList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
            <el-select
              v-model="conf.fontSize"
              size="mini"
              filterable
              allow-create
              default-first-option
              style="width: 49%"
            >
              <el-option
                v-for="item in fontSizeList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </div>
        </attr-row>

        <attr-row :label="$t('lcd.Editor.Border Radius')" :height="38">
          <div style="display: flex; justify-content: space-between">
            <el-input
              v-model="conf.borderRadius.leftTop"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 48%"
              @change="changeRadius"
            ></el-input>
            <el-input
              v-model="conf.borderRadius.rightTop"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 48%"
              @change="changeRadius"
            ></el-input>
          </div>
          <div
            style="
              height: 20px;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;
            "
          >
            <i
              class="icon iconfont icon-guanlian"
              :style="{
                fontWeight: '700',
                fontSize: '16px',
                color: conf.borderRadiusLock ? '#35b871' : '#e2e2e2',
              }"
            ></i>
            <!-- @click="changeBorderRadiusLock" -->
          </div>
          <div style="display: flex; justify-content: space-between">
            <el-input
              v-model="conf.borderRadius.leftBottom"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 48%"
              @change="changeRadius"
            ></el-input>
            <el-input
              v-model="conf.borderRadius.rightBottom"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 48%"
              @change="changeRadius"
            ></el-input>
          </div>
        </attr-row>

        <attr-row
          :label="$t('lcd.Editor.Rotate')"
          :height="38"
          class="custom-smaller-slider-btn2"
        >
          <el-slider
            v-model="conf.rotate"
            :min="0"
            :max="360"
            style="margin-left: 10px"
          />
          <el-input-number
            v-model="conf.rotate"
            controls-position="right"
            :min="0"
            :max="360"
            size="mini"
          />
          <div style="height: 10px"></div>
          <el-checkbox
            v-model="conf.spaceLineBreak"
            @change="changeSpaceLineBreak"
          >
            {{ $t("lcd.Editor.spaceLineBreak") }}
          </el-checkbox>
          <el-checkbox v-model="conf.autoZoom" @change="changeZoom">
            {{ $t("lcd.Editor.Auto Scale") }}
          </el-checkbox>
          <div v-if="conf.autoZoom">
            <div style="height: 10px"></div>
            <el-select
              v-model="conf.autoZoomMinFontSize"
              size="mini"
              filterable
              allow-create
              placeholder="AutoZoomModel Min FontSize"
              default-first-option
              style="width: 100%"
              @change="autoZoomMinFontSizeChange"
            >
              <el-option
                v-for="item in fontSizeList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
            <div style="height: 10px"></div>
            <el-radio-group v-model="conf.autoZoomLineBreak">
              <el-radio size="mini" :label="true">{{
                $t("lcd.Editor.autoZoomLineBreak")
              }}</el-radio>
              <el-radio size="mini" :label="false">{{
                $t("lcd.Editor.autoZoomOverhidden")
              }}</el-radio>
            </el-radio-group>
          </div>
        </attr-row>

        <!-- 显示逻辑 -->
        <attr-row
          :label="$t('lcd.Editor.isShow')"
          class="tt"
          style="position: relative"
        >
          <el-radio-group v-model="conf.hide">
            <el-radio size="mini" :label="true">{{
              $t("lcd.Editor.hide text")
            }}</el-radio>
            <el-radio size="mini" :label="false">{{
              $t("lcd.Editor.show text")
            }}</el-radio>
          </el-radio-group>
          <!-- {{conf.showLogic}} -->
          <el-button
            class="logicBtn"
            type="text"
            size="mini"
            @click.native="showLogicDialog"
            >{{ $t("lcd.Editor.show logic") }}</el-button
          >
        </attr-row>

        <!-- 超出显示效果 -->
        <!-- <attr-row :label="$t('lcd.Editor.Beyond display')" class="tt">
          <el-radio-group v-model="conf.exceedingDisplay">
            <el-radio size="mini" label="1">{{
              $t("lcd.Editor.Beyond hidden")
            }}</el-radio>
            <el-radio size="mini" label="2">{{
              $t("lcd.Editor.Autoscale")
            }}</el-radio>
          </el-radio-group>
        </attr-row> -->
      </el-tab-pane>
    </el-tabs>
    <LogicDialog
      :logicDetail="conf.showLogic"
      ref="logicRef"
      @getLogic="getLogic"
    ></LogicDialog>
  </div>
</template>

<script>
import transparentBg from "../../../assets/imgs/icon-tr-bg.png";
import store from "../../../store/index.js";
import {
  predefineColors,
  colorList,
  fontList,
  fontSizeList,
} from "../../../utils/constant.js";
import AttrRow from "../../tumeng-attr-row/src/index.vue";
import LogicDialog from "../../tumeng-display/src/index.vue";

export default {
  name: "TumengTextEdit",
  props: {
    goodsFields: {
      type: Array,
      default: function () {
        return [];
      },
    },
    userFontList: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  components: { AttrRow, LogicDialog },
  data() {
    return {
      transparentBg,
      isMore: false,
      fontSpecial: [
        {
          value: 0,
          label: this.$t("lcd.Editor.No Drift"),
        },
        {
          value: 1,
          label: this.$t("lcd.Editor.Top Drift"),
        },
        {
          value: 2,
          label: this.$t("lcd.Editor.Middle Drift"),
        },
        {
          value: 3,
          label: this.$t("lcd.Editor.Bottom Drift"),
        },
      ],
      state: store.state,
      predefineColors,
      colorList,
      allFontList: Array.from(
        new Set([
          ...fontList,
          ...JSON.parse(localStorage.getItem("userFontList")),
        ])
      ),
      fontSizeList,
      dictScrollDirection: [
        { label: "无", value: "" },
        { label: "左", value: "left" },
        { label: "右", value: "right" },
        { label: "上", value: "up" },
        { label: "下", value: "down" },
      ],
      // 滚动的intervalId
      intervalId: undefined,
      canvasWidth: store.state.programInfo.width,
      canvasHeight: store.state.programInfo.height,
    };
  },
  computed: {
    pageColor() {
      return this.state.programInfo.color ? this.state.programInfo.color : "";
    },
    conf: {
      get() {
        return this.state.activeComponent;
      },
    },
    clipShapObj() {
      return store.state.activeComponent.clipShap || {};
    },
    // goodsFields() {
    //   let fields = null;
    //   console.log(
    //     "=======>>>>>>>>>>",
    //     store.state.programInfo.templateGroupId
    //   );
    //   console.log(
    //     "=======>>>>>>>>>>",
    //     store.state.programInfo.goodsFields
    //   );
    //   if (store.state.programInfo.templateGroupId == 0) {
    //     fields = store.state.programInfo.goodsFields;
    //   }
    //   if (fields) {
    //     return fields;
    //   }
    //   return undefined;
    // },
  },
  methods: {
    changeRangeX(e) {
      console.log("X", e);
      console.log(this.canvasWidth, this.canvasHeight);
      let confX = +e;
      if (confX > this.canvasWidth - this.conf.width) {
        confX = this.canvasWidth - this.conf.width;
      }
      // if (confX < 0) {
      //   confX = 0;
      // }
      this.conf.left = confX;
    },
    changeRangeY(e) {
      let confY = +e;
      if (confY > this.canvasHeight - this.conf.height) {
        confY = this.canvasHeight - this.conf.height;
      }
      // if (confY < 0) {
      //   confY = 0;
      // }
      this.conf.top = confY;
    },
    changeRangeW(e) {
      let confW = +e;
      if (confW > this.canvasWidth - this.conf.left) {
        confW = this.canvasWidth - this.conf.left;
      }
      if (confW < 0) {
        confW = 0;
      }
      this.conf.width = confW;
    },
    changeRangeH(e) {
      let confH = +e;
      if (confH > this.canvasHeight - this.conf.top) {
        confH = this.canvasHeight - this.conf.top;
      }
      if (confH < 0) {
        confH = 0;
      }
      this.conf.height = confH;
    },
    borderWidthChange(e) {
      let confBW = +e;
      console.log("confBW", confBW);
      if (this.conf.height >= this.conf.width) {
        console.log(this.conf.width / 2);
        if (confBW > Math.floor(this.conf.width / 2)) {
          this.conf.borderWidth = Math.floor(this.conf.width / 2);
        }
      } else {
        console.log(this.conf.height / 2);
        if (confBW > Math.floor(this.conf.height / 2)) {
          this.conf.borderWidth = Math.floor(this.conf.height / 2);
        }
      }
    },
    changeTA(ta) {
      this.conf.textAlign = ta;
    },
    changeVA(va) {
      this.conf.verticalAlign = va;
    },
    handleClickBold() {
      this.conf.isBold = !this.conf.isBold;
    },
    handleClickItaly() {
      this.conf.isItaly = !this.conf.isItaly;
    },
    handleClickTurn() {
      this.conf.autoTurn = !this.conf.autoTurn;
      this.conf.autoZoom = false;
    },
    handleClickDirection() {
      this.conf.editDirection = !this.conf.editDirection;
    },
    handleClickUnderline() {
      const text = this.conf.isUnderline === "underline" ? "none" : "underline";
      this.conf.isUnderline = text;
    },
    handleClickDeleteline() {
      const text =
        this.conf.isUnderline === "line-through" ? "none" : "line-through";
      this.conf.isUnderline = text;
    },
    // 改变为空格换行时
    changeSpaceLineBreak() {
      if (this.conf.spaceLineBreak) {
        this.conf.autoTurn = true;
        this.conf.autoZoom = false;
      } else {
        this.conf.autoTurn = false;
        this.conf.autoZoom = true;
      }
    },
    // 改变缩放状态时
    changeZoom() {
      if (this.conf.autoZoom) {
        this.conf.autoTurn = false;
        this.conf.spaceLineBreak = false;
      } else {
        this.conf.autoZoomMinFontSize = 0;
      }
    },

    // 自动缩放时 字体
    autoZoomMinFontSizeChange() {
      // this.conf.autoZoom
      if(this.conf.fontSize < this.conf.autoZoomMinFontSize){
        this.conf.autoZoomMinFontSize = this.conf.fontSize
        this.$message.warning(this.$t("lcd.Editor.zoomFontSize setting waring"));
      }
    },

    // 改变分隔符状态
    fontSpecialChekedChange() {
      store.state.activeComponent.fontSpecialChecked =
        !store.state.activeComponent.fontSpecialChecked;
    },
    changeBorderRadiusLock() {
      this.conf.borderRadiusLock = !this.conf.borderRadiusLock;
    },
    changeRadius(data) {
      const maxNum =
        this.conf.width > this.conf.height
          ? this.conf.height / 2
          : this.conf.width / 2;
      data = data > maxNum ? maxNum : data;
      // console.log(data)
      if (this.conf.borderRadiusLock) {
        this.conf.borderRadius.leftTop = data;
        this.conf.borderRadius.rightTop = data;
        this.conf.borderRadius.rightBottom = data;
        this.conf.borderRadius.leftBottom = data;
      }
    },
    // datasetFieldChange   动态字段变化时
    datasetFieldChange() {
      for (let i = 0; i < this.goodsFields.length; i++) {
        if (
          this.conf.datasetField &&
          this.conf.datasetField === this.goodsFields[i].value
        ) {
          this.conf.name = this.goodsFields[i].label;
        }
        if (!this.conf.datasetField) {
          this.conf.name = this.conf.text ? this.conf.text : "Text";
        }
      }
    },

    showLogicDialog() {
      this.$refs.logicRef.open();
      console.log(12333333);
    },
    getLogic(val) {
      console.log(val);
      this.conf.showLogic = val;
    },

    // 修改字体颜色
    changeFontColor(index) {
      this.conf.fontColor = this.colorList[index].color;
    },
    // 修改文本填充色背景色
    changeBgColor(index) {
      this.conf.bgColor = this.colorList[index].color;
    },
    // changeBorderColor
    changeBorderColor(index) {
      this.conf.borderColor = this.colorList[index].color;
    },
  },
};
</script>

<style lang="scss" scoped>
.TmTextEdit {
  margin: 8px;
  .style-pane {
    // 时长样式
    .duration {
      div.el-input-number {
        width: 100%;
      }

      ::v-deep span.el-input-number__decrease,
      ::v-deep span.el-input-number__increase {
        display: none;
      }

      ::v-deep input.el-input__inner {
        padding: 0 15px;
        text-align: justify;
      }
    }

    // 横纵坐标、宽高样式
    @import "../../../assets/style/ltwh";
    // 加粗、倾斜、下划线那一行按钮变小
    .custom-smaller-btn {
      ::v-deep button.el-button {
        padding: 5px 11px;
      }
      ::v-deep .el-button--primary.is-plain:hover {
        background: #ffffff;
        border: 1px solid #dcdfe6;
        color: #606266;
      }
    }

    // 行高的样式
    .custom-smaller-slider-btn {
      // 拖拽点变小
      ::v-deep .el-slider__button {
        border-width: 1px;
        width: 10px;
        height: 10px;
      }

      // 指定slider宽度
      ::v-deep .el-slider {
        width: calc(100% - 66px);
        margin-right: 16px;
        float: left;
      }

      // 隐藏数字控制按钮
      ::v-deep span.el-input-number__increase,
      ::v-deep span.el-input-number__decrease {
        display: none;
      }

      // 隐藏数字输入框的padding
      ::v-deep div.el-input-number div.el-input > input.el-input__inner {
        padding: 0;
      }

      // 指定输入框的宽度
      ::v-deep .el-input-number {
        width: 50px;
        float: left;
        margin-top: 5px;
      }
    }

    // 旋转的样式
    .custom-smaller-slider-btn2 {
      // 拖拽点变小
      ::v-deep .el-slider__button {
        border-width: 1px;
        width: 10px;
        height: 10px;
      }

      // 指定slider宽度
      ::v-deep .el-slider {
        width: calc(100% - 86px);
        margin-right: 16px;
        float: left;
      }

      // 隐藏数字控制按钮
      ::v-deep span.el-input-number__increase,
      ::v-deep span.el-input-number__decrease {
        display: none;
      }

      // 隐藏数字输入框的padding
      ::v-deep div.el-input-number div.el-input > input.el-input__inner {
        padding: 0;
      }

      // 指定输入框的宽度
      ::v-deep .el-input-number {
        width: 60px;
        float: left;
        margin-top: 5px;
      }
    }

    .custom-color-picker {
      ::v-deep span.el-color-picker__icon.el-icon-arrow-down {
        display: none;
      }

      ::v-deep div.el-color-picker__trigger {
        border: none;
      }
    }

    // 滚动方向
    .dir {
      .el-radio {
        margin-right: 5px;

        ::v-deep .el-radio__label {
          padding-left: 2px;
        }
      }
    }
  }

  .explain {
    line-height: 30px;
  }
}
.sizeBtn {
  // flex: 1;
  width: 25px;
  margin-left: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ::v-deep .el-button.el-button--mini {
    font-size: 12px !important;
  }
  ::v-deep .el-button {
    height: 14px;
    padding: 0 5px;
    margin: 0;
  }
}
.custom-smaller-slider-btn2 {
  .radius-box {
    ::v-deep .el-slider {
      width: 100% !important;
    }
    ::v-deep .el-input-number {
      float: right !important;
    }
    ::v-deep .el-slider__input {
      width: 60px !important;
    }
    ::v-deep .el-slider__runway.show-input {
      margin-right: 76px !important;
    }
    ::v-deep .el-slider__stop {
      display: none;
    }
    ::v-deep .el-slider__marks-text {
      margin-top: 5px;
    }
  }
}
::v-deep .el-tabs__item.is-active {
  background-color: #f5f7fa !important;
  border-radius: 5px 5px 0 0 !important;
}
// ::v-deep .el-tabs > .el-tabs__header .el-tabs__item.is-active{
//   background-color: #f5f7fa !important;
//   border-radius: 5px 5px 0 0 !important;
// }
.logicBtn {
  position: absolute;
  top: 0px;
  right: -15px;
  z-index: 101;
  &.el-button.el-button--mini {
    font-size: 12px;
  }
}
</style>

<style lang="scss">
.TmTextEdit .el-input-group__append,
.TmTextEdit .el-input-group__prepend {
  padding: 0 10px;
}
</style>